import React from 'react';
import SubmissionsList from './SubmissionsList';

const SubmissionsPage: React.FC = () => {
    return (
        <div className="submissions-page-container">
            <SubmissionsList />
        </div>
    );
};

export default SubmissionsPage;